/* Vivaraki: couleur ou taille changer dans le panier latéral.
   Retire la ligne et ajoute la nouvelle variante avec la même quantité, puis
   recharge le contenu du panier (section cart-drawer) et la bulle du panier.
   Écoute en phase de capture pour que cart.js de Dawn ne prenne pas le select
   pour un champ de quantité. */
(function () {
  if (window.__vvCart) return;
  window.__vvCart = true;

  function json(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok || d.status) throw d;
        return d;
      });
    });
  }

  function vernieuw() {
    return fetch(window.routes.cart_url + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) {
        return r.json();
      })
      .then(function (s) {
        var doc = new DOMParser().parseFromString(s['cart-drawer'], 'text/html');
        var nieuw = doc.querySelector('.drawer__inner');
        var oud = document.querySelector('#CartDrawer .drawer__inner');
        if (nieuw && oud) oud.innerHTML = nieuw.innerHTML;
        var bubbel = document.getElementById('cart-icon-bubble');
        var nieuweBubbel = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (bubbel && nieuweBubbel) bubbel.innerHTML = nieuweBubbel.innerHTML;
      });
  }

  function melding(regel, tekst) {
    var fout = regel.querySelector('.cart-item__error-text');
    if (fout) fout.textContent = tekst;
  }

  document.addEventListener(
    'change',
    function (e) {
      var select = e.target;
      if (!select.classList || !select.classList.contains('vv-item__select')) return;
      e.stopPropagation();

      // regel = een losse winkelwagenregel of een stuk in een groep (Kadir 10 okt), de varianten staan in het blok
      var regel = select.closest('[data-line-key]');
      var blok = select.closest('.vv-item');
      var bron = blok && blok.querySelector('.vv-item__variants');
      if (!bron) return;
      var varianten = JSON.parse(bron.textContent);
      var keuze = Array.prototype.map.call(regel.querySelectorAll('.vv-item__select'), function (s) {
        return s.value;
      });
      var doel = varianten.find(function (v) {
        return v.options.every(function (o, i) {
          return o === keuze[i];
        });
      });
      var huidig = regel.querySelector('.quantity__input');
      var huidigId = regel.dataset.variantId ? parseInt(regel.dataset.variantId, 10)
        : huidig ? parseInt(huidig.dataset.quantityVariantId, 10) : null;

      if (!doel || !doel.available) {
        melding(regel, 'Cette combinaison n’est plus disponible.');
        // keuze terugzetten naar wat in de winkelwagen staat
        var terug = varianten.find(function (v) {
          return v.id === huidigId;
        });
        if (terug) {
          regel.querySelectorAll('.vv-item__select').forEach(function (s, i) {
            s.value = terug.options[i];
          });
        }
        return;
      }
      if (doel.id === huidigId) return;

      var aantal = parseInt(regel.dataset.quantity, 10) || 1;
      // cadeau en andere eigenschappen blijven op de regel staan na het wisselen (11 okt)
      var props = {};
      // Liquid geeft item.properties als lijst van paren ([["naam","waarde"]]); add.js wil een object
      try {
        var ruw = JSON.parse(regel.dataset.props || '{}');
        if (Array.isArray(ruw)) ruw.forEach(function (kv) { if (kv && kv.length === 2) props[kv[0]] = kv[1]; });
        else if (ruw) props = ruw;
      } catch (err) { props = {}; }
      regel.classList.add('is-swapping');
      json(window.routes.cart_change_url + '.js', { id: regel.dataset.lineKey, quantity: 0 })
        .then(function () {
          return json(window.routes.cart_add_url + '.js', { items: [{ id: doel.id, quantity: aantal, properties: props }] }).catch(function (err) {
            // nieuwe variant lukt niet: oude terugzetten
            return json(window.routes.cart_add_url + '.js', { items: [{ id: huidigId, quantity: aantal, properties: props }] }).then(function () {
              throw err;
            });
          });
        })
        .then(vernieuw)
        .catch(function (err) {
          return vernieuw().then(function () {
            var eerste = document.querySelector('#CartDrawer .cart-item__error-text');
            if (eerste) eerste.textContent = (err && err.description) || 'Une erreur est survenue, veuillez réessayer.';
          });
        });
    },
    true
  );
})();
